// sessionStorage-based token storage (cleared on tab close; not shared across tabs).
// More XSS-resistant than localStorage: tokens don't persist beyond the active browser tab.
const storage = typeof window !== "undefined" ? window.sessionStorage : null;

export const tokenStore = {
  get(key) {
    return storage ? storage.getItem(key) : null;
  },
  set(key, value) {
    if (storage) storage.setItem(key, value);
  },
  remove(key) {
    if (storage) storage.removeItem(key);
  },
};

export const KEYS = {
  SESSION_TOKEN: "md_token",
  SESSION_CODE: "md_code",
  ADMIN_TOKEN: "md_admin_token",
};
